import React, { useContext, useEffect, useState } from 'react'
import { Grid, Typography, useMediaQuery } from '@mui/material';
import IconsColor from '../../../utility/iconsColor';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { useSearchParams } from 'react-router-dom';
import agent from '../../../../services/api';
import { MetaContext, MetaContextPayload } from '../../../../context/metaContext';
import { Category, chatbotIntegrationAssignmentData, chatbotIntegrationAssignmentDataNew, createMetaIntegrationPayloadNew, DataItem, getInstagramAccessTokenResponse, globalIntegration, metaIntegrationAccessTokenData, metaIntegrationFaceBookDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import { checkForErrorCode, FACEBOOK_LOGIN_SCOPE, isAgentOrAdmin, isOrganizationRoleAgent } from '../../../../utils/constants';
import { ChatbotContext, ChatbotContextPayload } from '../../../../context/chatbotContext';
import GlobalPopUp from '../../../utility/globalPopUp';
import GlobalDeletePopup from '../../../utility/globalDeletePopup/globalDeletePopup';
import facebookIcon from "../../../../assets/images/channels/facebook/facebookMessenger.svg";
import GlobalButton from '../../../utility/globalButton/button';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import integrationStyles from '../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import ShowAvailablePages from './showAvailablePages';
import FacebookInformationCard from '../../../utility/facebookInformationCard';
import ChatbotFacebookIntegrationSetup from '../chatbotFacebookIntegrationSetup';
import globalStyles from "../../../../assets/styles/global.module.scss";
import { GenericDataContext, GenericDataContextPayload } from '../../../../context/genericDataContext';
import { AIChatbotBreadcrumb, chatbotDetailsBreadcrumb, homeBreadcrumb } from '../../../../utils/breadcrumb';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { useIntegrationStore } from '../../../../store/integrationStore';

interface linkedPageData {
    chatbot_integration_assignment_data: chatbotIntegrationAssignmentData[],
    created_at_timestamp: string,
    instagram_id: string,
    instagram_username: string,
    meta_integration_access_token_data: metaIntegrationAccessTokenData,
    meta_integration_facebook_flag_webhook: boolean,
    meta_integration_facebook_id: number,
    page_category: string,
    page_id: string,
    page_name: string,
    meta_integration_id: number,
    meta_integration_type_id: number,
}
declare global {
    interface Window {
        fbAsyncInit: () => void;
        FB: any;
    }
}

interface addChatbotIntegrationDetailsInterface {
    // meta_integration_id: string,
    chatbot_id: string,
    integrated_channel_id: string
    // page_id: string,
    // meta_integration_type_id: string
}

interface categoryList {
    id: string, 
    name: string,
}

interface responsePayload {
    access_token: string,
    page_id: string,
    page_name: string,
    page_category: string, 
    page_categoryList: categoryList[],
}

const ChatbotFacebookIntegration = () => {
    const smallScreen = useMediaQuery('(max-width : 900px) and (min-width : 0px)')
    const mediaScreen = useMediaQuery('(max-width : 1200px) and (min-width : 0px)')
    const [flagFacebookIntegrationExist, setflagFacebookIntegrationExist] = useState<boolean | null>(null)
    const [searchParams] = useSearchParams();
    const chatbot_id = searchParams.get('chatbot_id');
    let pathname = window.location.pathname.toLowerCase();

    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload;
    const { metaCredentials, GetMetaCredentials } = useContext(MetaContext) as MetaContextPayload;
    const { setShowIntegrationDetails } = useContext(MetaContext) as MetaContextPayload;
    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { getMetaIntegrationList, globalIntegrationTypeList, integrationListNewStructure, setIntegrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { setFlagIntegrationNotAvailablePopup } = useIntegrationStore((useShallow((state) => ({
        setFlagIntegrationNotAvailablePopup: state.setFlagIntegrationNotAvailablePopup
    }))))

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [phoneNumberIntegrate, setPhoneNumberIntegrate] = useState<string>("")
    const [linkedPagesData, setLinkedPagesData] = useState<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[]>([])

    const [flagShowAvailablePages, setFlagShowAvailablePages] = useState<boolean>(false)
    const [availablePagesData, setAvailablePagesData] = useState<(metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[]>([])
    const [showConfirmationPopover, setShowConfirmationPopover] = useState<boolean>(false);
    const [confirmationPopoverAnchorEl, setConfirmationPopoverAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [addChatbotIntegrationDetails, setAddChatbotIntegrationDetails] = useState<addChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [removeChatbotIntegrationDetails, setRemoveChatbotIntegrationDetails] = useState<addChatbotIntegrationDetailsInterface>({
        chatbot_id: "",
        integrated_channel_id: ""
    })
    const [responsePayload, setResponsePayload] = useState<responsePayload[] | null>(null);

    async function getmetaIntegrationList() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getMetaIntegrationList(true)
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useEffect(() => {
        (async () => {
            if (responsePayload && responsePayload.length > 0) {

                let metaIntegrationTypeId = globalIntegrationTypeList.find((type) => type.channel_name.toLowerCase() === "facebook")?.channel_id ?? Number(process.env.REACT_APP_FACEBOOK_META_INTEGRATION_TYPE_ID);

                if (!metaIntegrationTypeId) {
                    console.error("Meta Integration Type ID for Facebook is undefined");
                    return;
                }

                const facebookPayload: createMetaIntegrationPayloadNew = {
                    channel_id: metaIntegrationTypeId,
                    meta_integration_facebook_data: responsePayload?.map((page: responsePayload) => ({
                        page_id: page?.page_id,
                        page_name: page?.page_name,
                        page_category: page?.page_category,
                        access_token_value: page?.access_token,
                    })),
                    channel_authoriser_user_data: {
                        authoriser_unique_id: Number(responsePayload?.[0]?.page_id),
                        authoriser_unique_name: responsePayload?.[0]?.page_name,
                        authoriser_unique_email: "",
                    },
                    meta_data: JSON.stringify(responsePayload),
                };
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

                const response = await agent.createMetaIntegration.post(facebookPayload);
                if (response.status) {
                    showSuccess("Integration Successfull!")
                    let responseNewStructure = response.data[0]
                    let whatsappIntegrations = responseNewStructure.meta_integration_whatsapp_data.map((integration: any) => {
                        return {
                            ...integration,
                            integrated_channel_id: integration.meta_integration_whatsapp_id,
                            channel_name: 'Whatsapp'
                        }
                    })
                    setIntegrationListNewStructure([...whatsappIntegrations, ...responseNewStructure.meta_integration_facebook_data, ...responseNewStructure.meta_integration_instagram_data
                    ])
                    let sortedData = responseNewStructure.meta_integration_facebook_data.sort((a: globalIntegration, b: globalIntegration) => new Date(b.created_at_timestamp).getTime() - new Date(a.created_at_timestamp).getTime())
                    let data = sortedData[0]
                    let chatbot_id = searchParams.get('chatbot_id')
                    if (chatbot_id) {
                        let payload = {
                            chatbot_id: chatbot_id,
                            integrated_channel_id: data.integrated_channel_id
                        }
                        AddChatbotIntegration(payload)
                    }
                }
                else {
                    let errorCode = checkForErrorCode(response)
                    if (response.message == "canceled") {
                    }
                    else {
                        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
                        handleError(response);
                    }
                    safeLogout()
                }
            }
        })();
    }, [responsePayload]);

    function addChatbotIntegration(display_page_name: string, integrated_channel_id: string, event?: React.MouseEvent<HTMLButtonElement>) {
        if (event) {
            handleClick(event)
        }
        let chatbot_id = searchParams.get('chatbot_id')
        if (chatbot_id) {
            setAddChatbotIntegrationDetails((prevState) => ({
                ...prevState,
                chatbot_id: chatbot_id,
                integrated_channel_id: integrated_channel_id
            }))
        }
        setPhoneNumberIntegrate(display_page_name)
    }

    useEffect(() => {
        getmetaIntegrationList()
    }, [])

    useEffect(() => {
        if (userDetail.flagUser && !isOrganizationRoleAgent(userDetail) && !isAgentOrAdmin(userDetail)) {
            if (!metaCredentials) {
                GetMetaCredentials();
            }
        }
    }, [metaCredentials, userDetail])

    useEffect(() => {
        const updatedBreadcrumbs = [
            {...homeBreadcrumb}, 
            AIChatbotBreadcrumb, 
            {...chatbotDetailsBreadcrumb, name: chatBotDetails?.chatbot_name ? chatBotDetails?.chatbot_name : "Chatbot", path: `/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot_id}`}, 
            { name: "Facebook Integration", path: `${pathname}?chatbot_id=${chatbot_id}` , isActive: true}
        ]; 
        setBreadCrumbs(updatedBreadcrumbs);
    }, [chatBotDetails])

    useEffect(() => {
        let ids: any = []
        if (integrationListNewStructure !== null && integrationListNewStructure.length > 0) {
            let facebookFilter = integrationListNewStructure?.filter((integration: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)) => integration.channel_name.toLowerCase() == "facebook");
            facebookFilter?.map((data: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)) => {
                if ("chatbot_integration_assignment_data" in data) {
                    data?.chatbot_integration_assignment_data.map((assignmentData: chatbotIntegrationAssignmentDataNew) => {
                        ids.push(String(assignmentData.chatbot_id ?? assignmentData?.ai_chatbot_id))
                    })
                }
            })
            let validID = ids.includes(chatBotDetails?.chatbot_id);
            setAvailablePagesData(facebookFilter)
            if (validID && facebookFilter.length > 0) {
                let linkedPhoneNumber: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew)[] = facebookFilter.filter((facebookPages: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => {
                    if ("chatbot_integration_assignment_data" in facebookPages) {
                        return facebookPages?.chatbot_integration_assignment_data.some((chatbot) => (chatbot?.chatbot_id ?? chatbot?.ai_chatbot_id)?.toString() == searchParams.get('chatbot_id'))
                    }
                }
                )
                setLinkedPagesData(linkedPhoneNumber)
                setflagFacebookIntegrationExist(true)
                setShowIntegrationDetails(true)
            } else {
                setflagFacebookIntegrationExist(false)
                setShowIntegrationDetails(false)
            }
        } else {
            setflagFacebookIntegrationExist(false)
            setShowIntegrationDetails(false)
        }

    }, [chatBotDetails, window.location.href, integrationListNewStructure])

    useEffect(() => {
        if (metaCredentials) {
            (function (d, s, id) {
                let js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s) as HTMLScriptElement;
                js.id = id;
                js.src = "https://connect.facebook.net/en_US/sdk.js";
                fjs.parentNode!.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        
            let facebookConfig = metaCredentials.find((configuration) => configuration.channel_name.toLowerCase() == "facebook")
            window.fbAsyncInit = function () {
                // @ts-ignore
                FB.init(facebookConfig.fb_init);
            };
        }
    }, [metaCredentials]);

    const safeLogout = (): void => {
        // Check the user's current login status
        window.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
                // User is logged in to your app and Facebook.
                // It's safe to call logout
                window.FB.logout((logoutResponse: any) => {
                    // Handle post-logout logic here
                });
            } else {
                console.log('User was not logged in via Facebook SDK. No need to log out.');
                // Handle scenarios where the user was not logged in
            }
        });
    };

    const getPagesList = () => {
        window.FB.api("/me/accounts", (result: getInstagramAccessTokenResponse) => {
            if (result && !result.error) {
                const pages: DataItem[]  = result.data;
                if (pages.length) {
                    const transformedData = pages?.map((page: DataItem) => ({
                        access_token: page.access_token,
                        page_id: page.id,
                        page_name: page.name,
                        page_category: page.category,
                        page_categoryList: page.category_list.map((cat: Category) => ({
                            id: cat.id,
                            name: cat.name
                        }))
                    }));
                    setResponsePayload(transformedData)
                }
                else {
                    showError("No page was selected while integrating.")
                }
            }
            else {
                console.log("Error fetching page access token:", result.error);
            }
        });
    };

    const loginToFacebook = () => {

        let facebookConfig = metaCredentials?.find((configuration) => configuration.channel_name.toLowerCase() == "facebook")

        if(!facebookConfig?.flag_can_integrate){
            setFlagIntegrationNotAvailablePopup(true);
            return;
        }

        window.FB.login((response: any) => {
            if (response.authResponse) {
                window.FB.api("/me", (res: any) => {
                    getPagesList();
                });
            } else {
                console.log("User cancelled login or did not fully authorize.");
            }
        }, { scope: FACEBOOK_LOGIN_SCOPE });
    };

    const deleteChatbotIntegration = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        let channel_id = globalIntegrationTypeList?.find((channel) => channel?.channel_name?.toLowerCase() == 'facebook')?.channel_id.toString() || ''
        const response = await agent.removeChatbotIntegration.delete(
            channel_id,
            removeChatbotIntegrationDetails.chatbot_id,
            removeChatbotIntegrationDetails.integrated_channel_id
        );
        if (response.status) {
            await getmetaIntegrationList()
            showSuccess("Integration Removed Successfully")
        } else {
            handleError(response);
        }
        setShowDeleteConfirmation(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    const handleRemoveChatbotIntegration = (integrated_channel_id: string, display_phone_number: string) => {
        if (integrationListNewStructure) {
            let chatbot_id = searchParams.get('chatbot_id')
            if (chatbot_id) {
                setRemoveChatbotIntegrationDetails(
                    {
                        chatbot_id: chatbot_id,
                        integrated_channel_id: integrated_channel_id
                    }
                )
            }
            setShowDeleteConfirmation(true)
            setPhoneNumberIntegrate(display_phone_number)
        }
    }

    async function AddChatbotIntegration(addChatbotIntegrationDetails: addChatbotIntegrationDetailsInterface) {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const response = await agent.addChatbotIntegration.post(addChatbotIntegrationDetails)
        if (response.status) {
            await getmetaIntegrationList()
            showSuccess("Integration Successfull!")
        } else {
            handleError(response);
        }
        setFlagShowAvailablePages(false)
        handleCloseConfirmationPopover()
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setConfirmationPopoverAnchorEl(event.currentTarget);
        setShowConfirmationPopover(true)
    };

    const handleCloseConfirmationPopover = () => {
        setConfirmationPopoverAnchorEl(null);
        setShowConfirmationPopover(false)
    };
    return (
        <>

            {flagShowAvailablePages &&
                <ShowAvailablePages
                    flagShowAvailableNumbers={flagShowAvailablePages}
                    setFlagShowAvailableNumbers={setFlagShowAvailablePages}
                    smallScreen={smallScreen}
                    showConfirmationPopover={showConfirmationPopover}
                    confirmationPopoverAnchorEl={confirmationPopoverAnchorEl}
                    handleCloseConfirmationPopover={handleCloseConfirmationPopover}
                    addChatbotIntegrationDetails={addChatbotIntegrationDetails}
                    AddChatbotIntegration={AddChatbotIntegration}
                    availablePhoneNumberData={availablePagesData}
                    handleRemoveChatbotIntegration={handleRemoveChatbotIntegration}
                    displayPhoneNumber={phoneNumberIntegrate}
                    launchWhatsAppSignup={loginToFacebook}
                    saveChatbotIntegrationData={addChatbotIntegration}
                />

            }
            {flagFacebookIntegrationExist == false ?
                <>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.startAlignmentStyle}  ${globalStyles.fullwidth}  ${globalStyles.containerFlexWrap} `}   gap={2}  pt={1}>
                    <Grid item className={globalStyles.fullwidth}>
                            <Grid container  className={`${globalStyles.createChatbotContainer} ${globalStyles.containerFlexWrap}`}  gap={"13px"} mt={mediaScreen ? 2 : 1} >
                                <Grid item className={globalStyles.displayFlexStyle}>
                                    <img alt="" src={facebookIcon} className={integrationStyles.whatsappIntegrationIcon} />
                                </Grid>
                                <Grid item>
                                    <Typography className={integrationStyles.whatsappIntegrationFontStyle}>Integrate with your Facebook Account</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {integrationListNewStructure &&
                            <Grid item className={globalStyles.wpIntegrationWrapper}>

                                <>
                                    {
                                        integrationListNewStructure?.filter((integration: metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew) => integration.channel_name.toLowerCase() === "facebook").length > 0 ?
                                            <>
                                                <Grid container className={globalStyles.flexColumn}>
                                                    <Grid item>
                                                        {/* <ChatbotWhatsAppIntegrationSetup launch={launchWhatsAppSignup} /> */}
                                                        <span className={globalStyles.textWpInt}>This Chatbot is not linked with any Facebook Pages yet. </span>
                                                    </Grid>
                                                    <Grid item className={globalStyles.padTop}>
                                                        <GlobalButton buttonText={"Add Facebook Page"} className='primaryButtonStyle' onClick={() => { setFlagShowAvailablePages(true) }} sx={{ padding: "6px 20px !important" }} startIcon={<IconsColor fillColor="#FFFFFF" iconName="plus" width="15px" height="15px" />} />
                                                    </Grid>
                                                </Grid>
                                            </>
                                            :
                                            <Grid container className={globalStyles.flexColumn}>
                                                <Grid item>
                                                    <ChatbotFacebookIntegrationSetup launch={loginToFacebook} />
                                                </Grid>
                                                <Grid item sx={{ borderTop: "1px solid #E1DCDC", paddingTop: "20px" }}>
                                                    <GlobalButton buttonText={"Integrate Facebook Account"} className='primaryButtonStyle' onClick={loginToFacebook} />
                                                </Grid>
                                            </Grid>
                                    }
                                </>
                            </Grid>}
                    </Grid>
                </>
                :
                <>
                    {integrationListNewStructure &&
                        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapLength} `} sx={{ padding: { xs: "15px 7px", lg: "15px 15px 15px 5px" } }} mt={{ xs: 1, lg: 0 }}>
                            <Grid item>
                                <Grid container className={globalStyles.gapLess}>
                                    {linkedPagesData.map((pageData: (metaIntegrationWhatsAppDataNew | metaIntegrationFaceBookDataNew | metIntegrationInstagramDataNew), index) => (
                                        <FacebookInformationCard
                                            integrationType='Facebook'
                                            key={index}
                                            flagDelete={false}
                                            title={`WhatsApp Account ${index + 1}`}
                                            currentlySelected={true}
                                            showRemoveChatbotIntegration={true}
                                            removeChatbotIntegration={() => { handleRemoveChatbotIntegration(String(pageData.integrated_channel_id), "page_name" in pageData ? pageData.page_name : "") }}
                                            details={{
                                                page_id: "page_id" in pageData ? pageData.page_id : "",
                                                integrated_channel_id: String(pageData.integrated_channel_id),
                                                page_name: "page_name" in pageData ? pageData.page_name : "",
                                                page_category: "page_category" in pageData ? pageData.page_category : "",
                                                linked_chatbots: "chatbot_integration_assignment_data" in pageData ? pageData.chatbot_integration_assignment_data : undefined,
                                            }}
                                            flagIntegration={true}
                                        />
                                    ))}
                                </Grid>
                            </Grid>
                            <Grid item>

                                <GlobalButton onClick={() => { setFlagShowAvailablePages(true) }} buttonText={"Add Facebook Pages"} className={'blackShadowedButton'}
                                    startIcon={<IconsColor fillColor="#A5A5A5" iconName="plus" width="19px" height="19px" />}
                                />
                            </Grid>

                        </Grid>}
                    {
                        showDeleteConfirmation &&
                        <GlobalDeletePopup
                            open={showDeleteConfirmation}
                            title={"Undeploy Chatbot Confirmation"}
                            deleteDescription={`Are you sure you want to undeploy ${chatBotDetails?.chatbot_name} from ${phoneNumberIntegrate}`}
                            onClose={() => { setShowDeleteConfirmation(false) }}
                            onDelete={deleteChatbotIntegration}
                            primaryButtonText={"Undeploy"}
                        />
                    }
                </>
            }

        </>
    )
}

export default ChatbotFacebookIntegration;